/* eslint-disable no-underscore-dangle */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isBrowser, isMobileOnly, isTablet } from 'react-device-detect';
/**
 * window may be undefined in Next.js apps
 */
if (typeof window !== 'undefined' && !(window === null || window === void 0 ? void 0 : window._SFDDL)) {
    window._SFDDL = {
        pageInfo: {
            Country_Language: '',
            SiteIdentifier: '',
            Device: '',
            PNL: '',
            ClientName: '',
            CustomerType: '',
            Product: '',
            PageKind: '',
            pageName: '',
            PageFunction: '',
            PageSubFunction: '',
            previouslyVisited: '',
            Token: '',
            Message: '',
            MessageType: '',
            numberOfAccounts: '',
            ErrorMessage: '',
            RelyingParty: ''
        }
    };
}
const device = (isBrowser && 'desk') ||
    (isMobileOnly && 'mobile') ||
    (isTablet && 'tab') ||
    '';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const analyticsConfig = Object.freeze({
    pageEvents: {},
    defaults: {
        Country_Language: '',
        SiteIdentifier: '',
        Device: device,
        PNL: '',
        ClientName: '',
        CustomerType: '',
        Product: '',
        PageKind: '',
        pageName: '',
        PageFunction: '',
        PageSubFunction: '',
        previouslyVisited: '',
        Token: '',
        Message: '',
        MessageType: '',
        numberOfAccounts: '',
        ErrorMessage: '',
        RelyingParty: ''
    }
});
const { pageEvents, defaults } = analyticsConfig;
// eslint-disable-next-line sonarjs/cognitive-complexity, max-lines-per-function
const populatePageInfo = (eventOptions) => {
    var _a, _b, _c, _d;
    const _e = eventOptions || {}, { countryLanguage, siteIdentifier, pnl, clientName, customerType, product, pageKind, pageName, pageFunction, pageSubFunction, pathName, previouslyVisited, token, message, messageType, numberOfAccounts, errorMessage, relyingParty } = _e, rest = __rest(_e, ["countryLanguage", "siteIdentifier", "pnl", "clientName", "customerType", "product", "pageKind", "pageName", "pageFunction", "pageSubFunction", "pathName", "previouslyVisited", "token", "message", "messageType", "numberOfAccounts", "errorMessage", "relyingParty"]);
    return Object.assign({ Country_Language: countryLanguage || defaults.Country_Language, SiteIdentifier: siteIdentifier || defaults.SiteIdentifier, Device: defaults.Device, PNL: pnl || defaults.PNL, ClientName: clientName || defaults.ClientName, CustomerType: customerType || defaults.CustomerType, Product: product || defaults.Product, PageKind: pageKind || ((_a = pageEvents[pathName]) === null || _a === void 0 ? void 0 : _a.PAGE_KIND) || defaults.PageKind, pageName: pageName || ((_b = pageEvents[pathName]) === null || _b === void 0 ? void 0 : _b.PAGE_NAME) || defaults.pageName, PageFunction: pageFunction ||
            ((_c = pageEvents[pathName]) === null || _c === void 0 ? void 0 : _c.PAGE_FUNCTION) ||
            defaults.PageFunction, PageSubFunction: pageSubFunction ||
            ((_d = pageEvents[pathName]) === null || _d === void 0 ? void 0 : _d.PAGE_SUB_FUNCTION) ||
            defaults.PageSubFunction, previouslyVisited: previouslyVisited || defaults.previouslyVisited, Token: token || defaults.Token, Message: message || defaults.Message, MessageType: messageType || defaults.MessageType, numberOfAccounts: numberOfAccounts || defaults.numberOfAccounts, ErrorMessage: errorMessage || defaults.ErrorMessage, RelyingParty: relyingParty || defaults.RelyingParty }, rest);
};
const triggerAnalyticsEvent = (eventOptions) => {
    if (typeof window === 'undefined')
        return;
    const populatedPageInfo = populatePageInfo(eventOptions);
    window._SFDDL.pageInfo = Object.assign(Object.assign({}, window._SFDDL.pageInfo), populatedPageInfo);
    const event = new CustomEvent('syfPageView');
    window.dispatchEvent(event);
};
export default triggerAnalyticsEvent;
